import { useMutation } from "@tanstack/react-query";
import services from "../services";

interface CreateManualDeliveryOptionInput {
  estimateNo: string;
  splitId: string;
  payload: any;
}

export const useCreateManualDeliveryOption = () => {
  return useMutation({
    mutationKey: ["deliveryOption", "create"],
    mutationFn: (data: CreateManualDeliveryOptionInput) =>
      services.createManualDeliveryOptionForEstimateSplit(
        data.estimateNo,
        data.splitId,
        data.payload
      ),
  });
};
